/** Trusted systems and external references (Phase 2 P2-4): beside import-en.ts. */
export default {
  trustedSystems: {
    title: 'Trusted systems',
    description:
      'Case packages signed by these systems are accepted as theirs. Each system publishes its signing keys as a key list.',
    empty: 'No trusted systems yet.',
    add: 'Add trusted system',
    edit: 'Edit',
    remove: 'Remove',
    removeConfirm: 'Remove {{system}}? Its packages will no longer verify here.',
    confirmRemove: 'Remove system',
    cancel: 'Cancel',
    save: 'Save',
    saved: 'The trusted system was saved.',
    dialogTitle: 'Trusted system',
    systemId: 'System id',
    systemIdTaken: 'A trusted system with this id exists: edit it instead.',
    systemIdHint: 'Your own short name for the system, in lower case, for example mbjb-osc. A forward names it.',
    name: 'Name',
    keySource: 'Signing keys',
    keySourceUrl: 'Fetch them from the system’s key list address',
    keySourceJwks: 'Paste the key list',
    jwksUrl: 'Key list address',
    jwksUrlHint: 'The https address the system gives you, for example its /planning/jwks address.',
    jwks: 'Key list (JSON)',
    jwksHint: 'The key list file the system sent you.',
    jwksAgain: 'Paste the key list again: it is replaced as a whole when you save.',
    requireSeal: 'Require signed packages for submissions this system holds',
    kids: 'Key ids',
    withheldKids:
      'Withheld: {{kids}}. Another trusted system publishes these keys too, so this entry does not verify with them. Save this entry to claim them, if they are its own.',
    fetchedAt: 'Keys fetched {{date}}',
    importTitle: 'Imported packages',
    importRequireSeal: 'Refuse packages not signed by a trusted system',
    importRequireSealHint:
      'On by default. A package that is unsigned, or signed with a key none of your trusted systems publishes, is refused. When off, such a package is imported as a read-only copy that nothing can update, with a warning; it never takes over a submission.',
    importRequireSealOff:
      'Packages that no trusted system signed will be accepted as read-only copies. Check where a package came from before you import it.',
    ruleOn: 'Every imported package must be signed by one of these systems (Imported packages, above).',
    ruleOff:
      'Packages these systems did not sign are imported as read-only copies, unless the system holding the submission requires signed packages (Imported packages, above).',
    ruleOnEmpty:
      'No trusted systems yet: while “Refuse packages not signed by a trusted system” is on, every imported package is refused.',
    reasons: {
      body: 'Check the fields and try again.',
      system_id:
        'Use lower-case letters, digits, dashes or underscores; “unverified”, “constructor” and “prototype” are reserved.',
      name: 'Enter a name of up to 200 characters.',
      key_source: 'Give either a key list address or a pasted key list, not both.',
      jwks: 'The key list is not a valid list of Ed25519 public keys.',
      private_key: 'The key list holds a private key. Paste only public keys.',
      kid_mismatch: 'A key id does not match its key.',
      kid_taken: 'Another trusted system already uses one of these keys.',
      limit: 'You can trust at most 100 systems.',
      jwks_url_invalid: 'The address must be an https address without a user name.',
      jwks_url_blocked: 'That address may not be fetched from here.',
      jwks_unreachable: 'The key list could not be fetched.',
      jwks_too_large: 'The key list is too large.',
      jwks_invalid: 'The address did not return a valid key list.',
    },
  },
  externalIds: {
    title: 'External references',
    intro: 'Ids other systems gave this submission, for example an OSC application id (osc3plus:id_permohonan).',
    empty: 'No external references.',
    scheme: 'Scheme',
    schemeHint: 'The kind of id, for example osc3plus:id_permohonan or osc3plus:id_projek.',
    issuer: 'Issued by',
    value: 'Id',
    link: 'Link reference',
    linked: 'The reference was linked.',
    imported: 'from an import',
    origin: 'Imported from {{system}} (their reference {{ref}}).',
    originUnverified: 'Imported from an unverified system (their reference {{ref}}).',
  },
}
